var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4523 3.23674C27.0956 -0.119949 21.6534 -0.119955 18.2967 3.23673L2.5175 19.0159C-0.839184 22.3726 -0.839191 27.8149 2.51749 31.1716L18.2967 46.9508C21.6534 50.3074 27.0956 50.3074 30.4523 46.9508L46.2315 31.1716C49.5882 27.8149 49.5882 22.3726 46.2315 19.0159L30.4523 3.23674ZM24.3745 36.6974C30.7831 36.6974 35.9782 31.5023 35.9782 25.0937C35.9782 18.6852 30.7831 13.49 24.3745 13.49C17.966 13.49 12.7708 18.6852 12.7708 25.0937C12.7708 31.5023 17.966 36.6974 24.3745 36.6974Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4967,
    cy: 25.216,
    r: 7.7358,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.5786
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4967,
    cy: 25.216,
    r: 3.8679,
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.3015779991752d83c6c6f929b4f7ff0a.svg";
export { ForwardRef as ReactComponent };